import { Practitioner } from "@/src/models/practitioner";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export async function getAllPractitioners(): Promise<Record<string, Practitioner>> {
  return fetchJSON<Record<string, Practitioner>>("/api/practitioners");
}

export async function getPractitionerById(practitionerId: string): Promise<Practitioner | null> {
  return fetchJSON<Practitioner | null>(`/api/practitioners/${practitionerId}`);
}

export async function getAllPatientPractitioners(patientId: string): Promise<Record<string, Practitioner>> {
  return fetchJSON<Record<string, Practitioner>>(`/api/patients/${patientId}/practitioners`);
}
